import { createReducer } from 'app-webtech-core/reducers/createReducer';
import { setEmbedConfigReducer } from './setConfig';
import { SET_CONFIG } from './../actions/types';

const defaultState = {
  enabled: false,
  corpEmbed: false,
};

export const embedReducer = createReducer(defaultState, {
  [SET_CONFIG]: setEmbedConfigReducer,
});
